import React from 'react'
import { View } from './View'
import {
  OrderData,
  useRefundOrder,
  RefundOrderRequest,
} from '../../../../../services/api/orders'
import { FormikHelpers } from 'formik'
import { isValidationError } from '../../../../../services/api/client/types'
import { notification } from 'antd'

type Form = RefundOrderRequest
type Props = {
  order: OrderData
  onSuccess?: () => void
}

export const Container: React.FunctionComponent<Props> = ({
  order,
  onSuccess,
}) => {
  const [refundOrder, { error }] = useRefundOrder(order.id)

  const onSubmit = (form: Form, { setErrors }: FormikHelpers<Form>) => {
    return refundOrder(form)
      .then(() => {
        if (onSuccess) {
          onSuccess()
        }
      })
      .catch((error) => {
        notification.error({
          message: 'Возникли ошибки при оформлении возврата',
          duration: 3,
        })
        if (isValidationError(error)) {
          setErrors(error.fieldErrors)
        }
      })
  }

  return (
    <View
      initialValues={{
        comment: '',
      }}
      onSubmit={onSubmit}
      error={error}
    />
  )
}
